export const DARK_PALETTE = [
  
  { hex: "#1a1a2e", label: "Midnight Navy" },
  { hex: "#16213e", label: "Deep Ocean" },
  { hex: "#0f3460", label: "Royal Blue" },
  { hex: "#162447", label: "Dark Sapphire" },
  { hex: "#1f4068", label: "Steel Blue" },
  { hex: "#0d2137", label: "Abyss Blue" },
  { hex: "#0a1931", label: "Night Sky" },
  { hex: "#1b3a5c", label: "Denim Dark" },
  { hex: "#1c3f5e", label: "Slate Ocean" },
  { hex: "#102a43", label: "Deep Teal Navy" },

  
  { hex: "#2c2c54", label: "Deep Violet" },
  { hex: "#2e1760", label: "Dark Plum" },
  { hex: "#1b1b2f", label: "Graphite Indigo" },
  { hex: "#3b1f6e", label: "Royal Grape" },
  { hex: "#2d1b69", label: "Twilight Purple" },
  { hex: "#1e0a3c", label: "Darkest Violet" },
  { hex: "#3a0ca3", label: "Electric Violet" },
  { hex: "#240046", label: "Black Currant" },
  { hex: "#3c096c", label: "Purple Haze" },
  { hex: "#4a0e8f", label: "Deep Amethyst" },

  
  { hex: "#1a3a2a", label: "Forest Dark" },
  { hex: "#1b4332", label: "Deep Forest" },
  { hex: "#143d2a", label: "Jungle Dark" },
  { hex: "#0d2b1d", label: "Dark Moss" },
  { hex: "#1e3a2f", label: "Hunter Green" },
  { hex: "#14281d", label: "Midnight Green" },
  { hex: "#1c3829", label: "Dark Emerald" },
  { hex: "#0f2d20", label: "Obsidian Green" },
  { hex: "#1a472a", label: "Fern Dark" },
  { hex: "#264653", label: "Teal Slate" },

  
  { hex: "#4a0404", label: "Dark Crimson" },
  { hex: "#6b0f1a", label: "Burgundy" },
  { hex: "#7b2d3e", label: "Dark Rose" },
  { hex: "#5c1a1a", label: "Deep Maroon" },
  { hex: "#3d0c02", label: "Burnt Umber" },
  { hex: "#4b1c1c", label: "Dark Garnet" },
  { hex: "#7a1628", label: "Wine Dark" },
  { hex: "#521c22", label: "Port Red" },
  { hex: "#3b0014", label: "Oxblood" },
  { hex: "#5e1224", label: "Merlot" },

  
  { hex: "#2d2d2d", label: "Charcoal" },
  { hex: "#1a1a1a", label: "Near Black" },
  { hex: "#212121", label: "Jet Black" },
  { hex: "#2b2b2b", label: "Graphite" },
  { hex: "#1f1f1f", label: "Onyx" },
  { hex: "#3a3a3a", label: "Dark Ash" },
  { hex: "#2f3640", label: "Gunmetal" },
  { hex: "#353b48", label: "Dark Slate" },
  { hex: "#2c3e50", label: "Wet Asphalt" },
  { hex: "#1c1c2e", label: "Rich Black" },
];
